import { actionTypeKeys } from "./../actions/actionTypeKeys";
import { AnyAction } from "redux";
import { initialState } from "../store/initialState";
import { SelectedAppointmentValues } from "../types/step";
import { internalActionKeys } from "src/internal/actions/internalActionKeys";

export default function selectedAppointmentValuesReducer(
  state: SelectedAppointmentValues = initialState.selectedAppointmentValues,
  action: AnyAction
): SelectedAppointmentValues {
  switch (action.type) {
    case actionTypeKeys.APPT_CREATED_BY:
      return { ...state, createdBy: action.name };
    case actionTypeKeys.APPT_HOLD_EXPIRED:
      return { ...state, timeSlot: null, slotOffsetMinutes: null };
    case actionTypeKeys.SET_ATTEMPTED_APPT:
      return { ...state, attemptedApptId: action.payload };
    case actionTypeKeys.SET_APPT_AUDIT:
      return { ...state, appLinkAuditKey: action.payload };
    case actionTypeKeys.BRANCH_SELECTED:
      return { ...state, branch: { ...action.branch } };
    case actionTypeKeys.CATEGORY_SELECTED:
      return { ...state, category: { ...action.category } };
    case actionTypeKeys.CLEAR_APPOINTMENT_VALUES:
      return {
        ...initialState.selectedAppointmentValues,
        appLinkAuditKey: state.appLinkAuditKey,
        createdBy: state.createdBy
      };
    case actionTypeKeys.LOGOUT_SUCCESS:
      return { ...initialState.selectedAppointmentValues, appLinkAuditKey: state.appLinkAuditKey };
    case actionTypeKeys.REASON_SELECTED:
      return { ...state, reason: { ...action.reason } };
    case actionTypeKeys.SERVICE_REP_SELECTED:
      return { ...state, serviceRep: { ...action.serviceRep } };
    case actionTypeKeys.TIME_SLOT_SELECTED:
      return { ...state, timeSlot: action.timeSlot, slotOffsetMinutes: action.slotOffsetMinutes };
    case actionTypeKeys.SET_APPOINTMENT_ADDITIONAL_INFO:
      return { ...state, additionalInfo: action.additionalInfo };
    case actionTypeKeys.SET_APPT_REP_SELECT_CODE:
      return { ...state, repSelectCode: action.repSelectCode };
    case internalActionKeys.SET_APPOINTMENT_CUSTOM_ADDRESS:
      return {
        ...state,
        customLocationAddress: action.customAddress
      };
    default:
      return state;
  }
}
